<template>
  <div class="step1" v-if="content.type==8&&content.show">
    <p>请任意选择素质项进行测评，至少选择5项,每项包含4-7个题</p>
    <div class="element-box1">
      <p>目标行动相关：</p>
      <ul class="direction-box">
        <li :class="[selected[0][index]?'selected':'',index>3?'col2':'col4']" v-for="(item,index) in content.option1" @click="selectCurrent(item,index,0)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>帮助与服务相关：</p>
      <ul class="direction-box">
        <li class="col2" :class="selected[1][index]?'selected':''" v-for="(item,index) in content.option2" @click="selectCurrent(item,index,1)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box1">
      <p>影响力相关：</p>
      <ul class="direction-box">
        <li :class="[selected[2][index]?'selected':'',index>2?'col2':'col3']" v-for="(item,index) in content.option3" @click="selectCurrent(item,index,2)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>管理相关：</p>
      <ul class="direction-box">
        <li class="col4" :class="selected[3][index]?'selected':''" v-for="(item,index) in content.option4" @click="selectCurrent(item,index,3)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box1">
      <p>认知相关：</p>
      <ul class="direction-box">
        <li :class="[selected[4][index]?'selected':'',index>2?'col4':'col3']" v-for="(item,index) in content.option5" @click="selectCurrent(item,index,4)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="element-box2">
      <p>自我认知相关：</p>
      <ul class="direction-box">
        <li class="col4" :class="selected[5][index]?'selected':''" v-for="(item,index) in content.option6" @click="selectCurrent(item,index,5)">{{item.name}}
        </li>
      </ul>
    </div>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      selected: [
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false],
          [false, false, false, false, false, false, false, false, false]
        ],
      chooseValue:[],
      totalCount:0,
      currentNum:-1,
      currentName:'',
      currentDefinition:''
    }
  },
  methods:{
    selectCurrent(item,index,sub){
      let num = -1
      this.chooseValue.map((pep,zindex)=>{
        if(pep.name==item.name){
          num = zindex
        }
      })
      if(num>=0){
        this.chooseValue.splice(num,1)
        this.$set(this.selected[sub], index, false)
      }else{
        this.chooseValue.push(item)
        this.$set(this.selected[sub], index, true)
      }
      if(this.chooseValue.length<5){
        this.content.errorMessage="至少选择5项"
        this.$emit("listenToChildEvent",[],this.content.num)
      }else{
        this.content.errorMessage=""
        this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .element-box1
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box2
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .element-box3
    background-color:#C1E7F0
    margin:0.1rem
    padding:0.1rem
  .direction-box
    overflow:hidden
    li
      float:left
      background-color:#FFFFFF
      margin:0.1rem
      padding:1px
      border-radius:6px
      display: flex;
      display:-webkit-flex;
      justify-content: center;/*水平居中*/
      align-items: center;/*垂直居中*/
      -webkit-align-items:center;
      height:0.8rem
      line-height:0.3rem
    .selected
      background-color:#DC6E5A
      color:#ffffff
    .col2
      width:46%
    .col3
      width:29%
    .col4
      width: 21%
      text-align: center
  .protrude
    color:#DC6E5A
    font-weight:bold
  .modal-box
    .modal-content
      background-color:#F5F5F5
      .modal-body
        background-color:#FFFFFF
        border:1px solid #BBBBBB
        margin:0.3rem
        padding:0.1rem
        .modal-title
          color:#434343
        .modal-text
          text-align:left
          color:#777777
      .tips
        color:#101010
      .btn-group
        overflow:hidden;
        width:90%
        margin:auto
        .default-btn
          display:inline-block
          width:44%
        .primary-btn
          float:left
          background-color:#008DCF
        .disabled-btn
          float:right
          background-color:#B5B5B5
</style>
